import axios from 'axios'
import store from '../store'
import { Toast } from 'vant'

// 创建axios实例
const service = axios.create({
  withCredentials: true,
  timeout: 50000 // 请求超时时间
})

// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['WP_SESSION_ID'] = store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 10000) {
      if (res.code === 71001) {
        console.log('扫码课件登录', res)
        return Promise.reject(response.data)
      }
      Toast.fail(res.message || '网络错误')
      return Promise.reject(response.data)
    } else {
      return response.data
    }
  },
  error => {
    console.log('err:' + error)
    try {
      if (error.response && error.response.status === 401) {
        Toast.fail('登录已过期')
        setTimeout(() => {
          store.dispatch('FedLogOut').then(() => {
            location.assign(location.origin) // 为了重新实例化vue-router对象 避免bug
          })
        }, 3000)
      } else {
        Toast.fail(error.message || '网络错误')
      }
      return Promise.reject(error)
    } catch (err) {
      console.log('catch:' + err)
    }
  }
)

const API = {
  get(url, params, callback) {
    return new Promise((resolve, reject) => {
      service.get(url, {
        params: params
      }).then((response) => {
        if (response && response.code === 10000) {
          callback && callback(response)
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getDirect(url, params, callback) {
    return new Promise((resolve, reject) => {
      service.get(url + '/' + params).then((response) => {
        if (response && response.code === 10000) {
          callback && callback(response)
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  post(url, params, callback) {
    return new Promise((resolve, reject) => {
      service.post(url, params).then((response) => {
        if (response && response.code === 10000) {
          callback && callback(response)
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  delete(url, params, callback) {
    return new Promise((resolve, reject) => {
      service.delete(url, {
        params: params
      }).then((response) => {
        if (response && response.code === 10000) {
          callback && callback(response)
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  deleteDirect(url, params, callback) {
    return new Promise((resolve, reject) => {
      service.delete(url + '/' + params).then((response) => {
        if (response && response.code === 10000) {
          callback && callback(response)
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  put(url, params, callback) {
    return new Promise((resolve, reject) => {
      service.put(url, params).then((response) => {
        if (response && response.code === 10000) {
          callback && callback(response)
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

export { API }
